<template>
  <div class="glide" :id="'glide_'+typeName">
    <div class="glide__track" data-glide-el="track">
      <ul class="glide__slides mx-5">
        <li v-for="(item, index) in htmlArray" :key="index" class="glide__slide">
          <GlideItem v-if="typeName === 'roastedPork'" :img-url="item.imgUrl"
                     :icon-url="item.iconUrl" :info="item.info"/>
          <FollowUsItem v-if="typeName === 'followUs'" :img-url="item.imgUrl"/>
          <JoinItem v-if="typeName === 'join'" :index="index" :item="item"/>
        </li>
      </ul>
    </div>
    <div class="glide__arrows" v-if="getShowArrow" data-glide-el="controls">
      <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
        <i class="arrow_left"/></button>
      <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
        <i class="arrow_right"/></button>
    </div>
  </div>
</template>

<script>
import * as GlideItemType from '../../src/shared/glide_item_type'
import Glide, {Controls, Breakpoints} from '@glidejs/glide'
import GlideItem from "./GlideItem/GlideItem";
import FollowUsItem from "./GlideItem/FollowUsItem";
import JoinItem from "./GlideItem/JoinItem";


export default {
  name: "Glide",
  components: {JoinItem, GlideItem, FollowUsItem},
  computed: {
    typeName() {
      switch (this.glideItemType) {
        case 0:
          return "roastedPork";
        case 1:
          return "followUs";
        case 2:
          return "join";
      }
    },
    getGap() {
      switch (this.glideItemType) {
        case 0:
          return 40;
        case 1:
          return 0;
        case 2:
          return 0;
      }
    },
    getPerView() {
      switch (this.glideItemType) {
        case 0:
          return 4;
        case 1:
          return 5;
        case 2:
          return 3;
      }
    },
    getBreakpoints() {
      switch (this.glideItemType) {
        case 0:
          return {
            1400: {
              perView: 4
            },
            1200: {
              perView: 3.5
            },
            1020: {
              perView: 3.2
            },
            900: {
              perView: 3
            },
            576: {
              perView: 3.4
            },
            540: {
              perView: 3.2
            },
            510: {
              perView: 3,
            },
            480: {
              perView: 2.8,
            },
            450: {
              perView: 2.6
            },
            410: {
              perView: 2.4
            },
            370: {
              perView: 2.2
            },
            340: {
              perView: 2
            }
          };
        case 1:
          return {
            1400: {
              perView: 5
            },
            1200: {
              perView: 4
            },
            900: {
              perView: 3
            },
            700: {
              perView: 2.5
            }
          };
        case 2:
          return {
            1400: {
              perView: 3
            },
            1200: {
              perView: 2
            },
            800: {
              perView: 1.5
            },
            600: {
              perView: 1.2
            },
            500: {
              perView: 1
            }
          };
      }
    },
    getShowArrow() {
      switch (this.glideItemType) {
        case 0:
          return false;
        case 1:
          return false;
        case 2:
          return false;
      }
    }
  },
  mounted() {
    new Glide(`#glide_${this.typeName}`, {
      // type: 'slider',
      type: 'carousel',
      startAt: 0,
      perView: this.getPerView,
      // focusAt: 'center',
      autoplay: 3000,
      gap: this.getGap,
      peek: {
        before: 0, after: 0,
      },
      breakpoints: this.getBreakpoints,
    },).mount({});
  }
  ,
  props: {
    glideItemType: {
      type: Number,
      default: 0,
    },
    htmlArray: {
      type: Array,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>


.arrow_right {
  width: 60px;
  height: auto;
  content: url('/img/image/icon/right_icon.png');
}

.arrow_left {
  width: 60px;
  height: auto;
  content: url('/img/image/icon/left_icon.png');

}

@media (max-width: 576px) {
  .arrow_left, .arrow_right {
    visibility: hidden;
  }
}

//.fit {
//  object-fit: contain;
//}
//
//@media (max-width: 1600px) {
//  .glide__arrow--left {
//    left: 45%;
//  }
//  .glide__arrow--right {
//    right: 45%;
//  }
//}
//
//@media (max-width: 1100px) {
//  .glide__arrow--left {
//    left: 42%;
//  }
//  .glide__arrow--right {
//    right: 42%;
//  }
//}
//
//@media (max-width: 700px) {
//  .glide__arrow--left {
//    left: 39%;
//  }
//  .glide__arrow--right {
//    right: 39%;
//  }
//}
//
//@media (max-width: 500px) {
//  .glide__arrow--left {
//    left: 32%;
//  }
//  .glide__arrow--right {
//    right: 32%;
//  }
//}
</style>
